// Translations
import form from '../sections/form/translations/tr'

// Translation: Login > Landing (Turkish)
export default Object.freeze({
	sections: { form }
})
